import Icon from '../Icon';
import {useKindCounts} from '../../api/posts';
import {FAMILY_FG, kindInfo, orderByUsage} from '../../lib/kinds';
import {Kind} from '../../types';

// The filter row under the Journal title: "All", "Happy" (the tells marked "makes me happy",
// whatever their kind), then the kinds by this gardener's use. Chips look 36px tall and carry a
// 44px tap box (DESIGN.md rule 7). "All" clears both.
type Props = {value: Kind | null; onChange: (kind: Kind | null) => void; happy?: boolean; onHappy?: (happy: boolean) => void; onAll?: () => void};

export default function KindChips({value, onChange, happy = false, onHappy, onAll}: Props) {
    const counts = useKindCounts();
    const kinds = orderByUsage(counts.data ?? {}).map(kindInfo);
    return (
        <div className="-mx-4 flex gap-2 overflow-x-auto px-4 py-1 [scrollbar-width:none]" role="group" aria-label="Filter by kind">
            <button type="button" className="chip" aria-pressed={value === null && !happy} onClick={() => (onAll ? onAll() : onChange(null))}>
                All
            </button>
            {onHappy && (
                <button type="button" className="chip pl-[10px]" aria-pressed={happy} onClick={() => onHappy(!happy)}>
                    <Icon name="happy" size={18} className={happy ? '' : 'text-marigold-text'} />
                    Happy
                </button>
            )}
            {kinds.map(k => (
                <button key={k.kind} type="button" className="chip pl-[10px]" aria-pressed={value === k.kind} onClick={() => onChange(value === k.kind ? null : k.kind)}>
                    <Icon name={k.icon} size={18} className={value === k.kind ? '' : FAMILY_FG[k.family]} />
                    {k.label}
                </button>
            ))}
        </div>
    );
}
